/*
===============================================================================================================
                                 Copyright 2025-2026, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import { merge } from 'lodash';

const packs = [
  'constants',
  'validation',
  'details',
  'branding',
  'reason-codes',
  'return-policies',
  'returns',
  'communications',
  'users',
  'statistics',
  'tracking',
  'login',
  'rules',
  'nonReturnableItems',
  'returnAddresses',
  'refunds',
  'merchants',
  'settings-countries',
  'customisation',
  'signup',
  'returnWindows',
  'carriers',
  'otherUtils',
  'navigation',
  'instoreReturns',
  'giftReturns',
];

export const getLocale = async ({ locale = 'en', carrier }) => {
  // Fall back to the base language if a regional variant has no dedicated locale pack
  // e.g. 'en-GB' falls back to 'en'
  const baseLocale = locale.includes('-') ? locale.split('-')[0] : locale;

  const imports = packs.map((pack) => import(`@/public/locales/${baseLocale}/${pack}.json`));

  let returnObject = {};
  await Promise.allSettled(imports).then((results) => {
    returnObject = packs.reduce((obj, item, index) => {
      if (results[index].status === 'rejected') return { ...obj };
      return ({
        ...obj,
        [item]: results[index].value.default,
      });
    }, {});
  });

  returnObject.wl = {};

  // Merge Default overrides in first
  try {
    const defaultOverridesImport = await import(`@/public/locales/${baseLocale}/overrides/DEFAULT.json`);
    merge(returnObject, defaultOverridesImport);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(`No default overrides for ${baseLocale} "/locales/${baseLocale}/overrides/DEFAULT"`);
  }

  try {
    const overridesImport = await import(`@/public/locales/${baseLocale}/overrides/${carrier}.json`);
    merge(returnObject, overridesImport);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(`No locale overrides for carrier "/locales/${baseLocale}/overrides/${carrier}"`);
  }

  return {
    data: returnObject,
  };
};

export default getLocale;
